<template>
  <div>
    <AppSkeletonMenu>
      <template v-slot>
        <div>Report Page</div>
      </template>
    </AppSkeletonMenu>
    <LoginPopUp v-if="!isLoggedIn" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import AppSkeletonMenu from '@/components/Skeleton/AppSkeletonMenu.vue';
import { useStore } from 'vuex';
import LoginPopUp from '@/components/PopUps/LoginPopUp.vue';

export default defineComponent({
  name: 'Reports',
  components: {
    AppSkeletonMenu,
    LoginPopUp,
  },
  setup() {
    const store = useStore();
    const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
    return { isLoggedIn };
  },
});
</script>
